import { Download } from 'lucide-react'

import { Button } from '@/components/button/button'

export const ImportContentHeader = () => {
  return (
    <div className="mb-8 flex items-center justify-between">
      <div>
        <h2 className="my-2 text-xl font-bold">Upload your file</h2>
        <div>
          Select a file containing applicant and case information. (Note: NVC cases cannot be added to the bulk upload
          file at this time)
        </div>
      </div>
      <Button className="bg-sky-100 text-foreground hover:bg-sky-100/85" asChild>
        <a className="flex" href="/example.csv">
          <Download className="mr-2" size={17} />
          Download example file (csv)
        </a>
      </Button>
    </div>
  )
}
